import React from 'react';
import { FaFacebook, FaInstagram, FaLinkedin, FaTwitter, FaPhone, FaEnvelope } from 'react-icons/fa';
import './Footer.css';

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-content">
          <div className="footer-section">
            <h3>Jeevika Property</h3>
            <p>
              Your trusted real estate partner in Vasai West since 2016. 
              We help you find your dream property with expert guidance and dedication.
            </p>
            <div className="social-links">
              <a href="#" aria-label="Facebook"><FaFacebook /></a>
              <a href="#" aria-label="Instagram"><FaInstagram /></a>
              <a href="#" aria-label="LinkedIn"><FaLinkedin /></a>
              <a href="#" aria-label="Twitter"><FaTwitter /></a>
            </div>
          </div>

          <div className="footer-section">
            <h4>Quick Links</h4>
            <ul>
              <li><a href="#about">About Us</a></li>
              <li><a href="#services">Services</a></li>
              <li><a href="#properties">Properties</a></li>
              <li><a href="#testimonials">Testimonials</a></li>
              <li><a href="#contact">Contact</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Services</h4>
            <ul>
              <li><a href="#services">Property Buying</a></li>
              <li><a href="#services">Property Selling</a></li>
              <li><a href="#services">Rental Services</a></li>
              <li><a href="#services">Consultation</a></li>
              <li><a href="#services">Legal Assistance</a></li>
            </ul>
          </div>

          <div className="footer-section">
            <h4>Contact Us</h4>
            <ul className="contact-list">
              <li>
                <FaPhone />
                <a href="tel:+919876543210">+91 98765 43210</a>
              </li>
              <li>
                <FaEnvelope />
                <a href="mailto:info@jeevikproperty.com">info@jeevikproperty.com</a>
              </li>
            </ul>
            <p className="footer-address">
              Opposite Wellness Forever<br />
              Vasai West, Mumbai<br />
              Maharashtra, India
            </p>
          </div>
        </div>

        <div className="footer-bottom">
          <p>&copy; {currentYear} Jeevika Property Consultant. All rights reserved.</p>
          <p>Designed with ❤️ for your dream home</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;